import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Seo from "@/components/seo/Seo";
import { publicApi } from "@/lib/api";
import { slugify } from "@/lib/slugify";

export default function RecursoDetalle() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    publicApi.resources().then((items) => setItem(items.find((entry) => (entry.slug || slugify(entry.titulo)) === slug) || null)).catch(() => setItem(null)).finally(() => setLoaded(true));
  }, [slug]);

  if (!loaded) return <main className="pt-32 text-center min-h-[60vh]">Cargando recurso…</main>;
  if (!item) return <main className="pt-32 text-center min-h-[60vh]"><Seo title="Recurso no encontrado" description="El recurso solicitado no está disponible." path={`/recursos/${slug}`} noindex />Recurso no encontrado. <Link to="/recursos" className="underline">Ver recursos</Link></main>;

  const description = item.seo_description || item.resumen;
  const canonical = `https://www.kbconsultoria.com/recursos/${slug}`;
  const schema = [{
    "@context": "https://schema.org", "@type": "Article", headline: item.titulo, description,
    datePublished: item.fecha || undefined, dateModified: item.actualizado || item.fecha || undefined,
    author: { "@type": item.autor ? "Person" : "Organization", name: item.autor || "KB Consultoría" },
    publisher: { "@type": "Organization", "@id": "https://www.kbconsultoria.com/#organization", name: "KB Consultoría" },
    image: item.imagen || "https://www.kbconsultoria.com/og-kb-consultoria.jpg", mainEntityOfPage: canonical,
  }, { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [
    { "@type": "ListItem", position: 1, name: "Inicio", item: "https://www.kbconsultoria.com/" },
    { "@type": "ListItem", position: 2, name: "Recursos", item: "https://www.kbconsultoria.com/recursos" },
    { "@type": "ListItem", position: 3, name: item.titulo, item: canonical },
  ] }];
  const paragraphs = String(item.contenido || item.resumen || "").split(/\n\s*\n/).filter(Boolean);

  return <main className="pt-[72px]">
    <Seo title={item.titulo} description={description} path={`/recursos/${slug}`} image={item.imagen} type="article" structuredData={schema} />
    <article>
      <div className="mx-auto max-w-[900px] px-5 md:px-10 py-8"><Link to="/recursos" className="inline-flex items-center gap-2 eyebrow"><ArrowLeft className="w-4 h-4" /> Recursos</Link></div>
      <header className="mx-auto max-w-[900px] px-5 md:px-10 py-12 border-b border-[#1A1A1A]/10">
        <div className="eyebrow">{item.tipo || "Artículo"}{item.fecha ? ` · ${item.fecha}` : ""}</div>
        <h1 className="mt-6 display-1">{item.titulo}</h1>
        <p className="mt-6 font-serif text-2xl text-[#1B3B2B]">{item.resumen}</p>
        {item.autor && <p className="mt-5 text-sm text-[#4A4A4A]">Por {item.autor}</p>}
      </header>
      <section className="mx-auto max-w-[800px] px-5 md:px-10 py-16" aria-label="Contenido del recurso">
        {paragraphs.map((paragraph, index) => <p key={index} className="mb-6 text-lg leading-relaxed">{paragraph}</p>)}
        <aside className="mt-14 bg-[#EFEBE2] p-8"><h2 className="font-serif text-3xl">¿Necesita aplicar este tema?</h2><p className="mt-3">Conversemos sobre el contexto y los objetivos de su organización.</p><Link to="/#contacto" className="kb-btn mt-6 inline-flex">Solicitar asesoría <ArrowUpRight className="w-4 h-4" /></Link></aside>
      </section>
    </article>
  </main>;
}
